/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2021 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import React from 'react';
import styles from "./ChartKey.scss";

export function ChartKey() {
    return (
        <div>
            <div className={"row no-gutters" + " " + styles["chart-key"]}>
                <div>
                    <div className="below-average">
                        <div className="row">
                            <div className={styles["below-average-box"]}></div>
                            <span className={styles["chart-key-text"]}>Low Average</span>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="mid-range">
                        <div className="row">
                            <div className={styles["mid-range-box"]}></div>
                            <span className={styles["chart-key-text"]}>Mid Average</span>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="above-average">
                        <div className="row">
                            <div className={styles["above-average-box"]}></div>
                            <span className={styles["chart-key-text"]}>High Average</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

